import { NeoReport, Report } from "@singularsystems/neo-reporting";
import React from 'react';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { ClientReportCategories } from "../ClientReportCategories";
import ServiceProviderApiClient from "../../../Maintenance/ApiClients/ServiceProviderApiClient";
import { Neo } from "@singularsystems/neo-react";
import { TextConstants } from "../../../Common/TextConstants";
import CashHoldingsExtractReportCriteria from "./CashHoldingsExtractReportCriteria";

@NeoReport("CashHoldingsExtract", { category: ClientReportCategories.HistoricDataReportExtracts })
export default class CashHoldingsExtractReport extends Report<CashHoldingsExtractReportCriteria> {
    public serviceProviderApiClient = new ServiceProviderApiClient();

    constructor() {
        super(CashHoldingsExtractReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingID}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup
                    appendText="fa-calendar"
                    label={TextConstants.Labels.ExportDate}
                    bind={this.criteria.meta.date} 
                />
            </Neo.GridLayout>
        </>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
                "columns": [
                    {
                        "key": "batchDate",
                        "width": 109
                    },
                    {
                        "key": "holdingDate",
                        "width": 109
                    },
                    {
                        "key": "stockbrokerCode",
                        "width": 109
                    },
                    {
                        "key": "accountCurrency",
                        "width": 109
                    },
                    {
                        "key": "instrumentType",
                        "width": 109
                    },
                    {
                        "key": "marketValue",
                        "width": 109
                    },
                    {
                        "key": "marketValueUSD",
                        "width": 109
                    },
                    {
                        "key": "exchangeRate",
                        "width": 147,
                        "formatString": "#,##0.000000000000000"
                    },
                    {
                        "key": "lastIssueDate",
                        "width": 109
                    }

                ]
            }
        } as Layout.IGridLayout;
    }
}